export default function iconWidget(editor) {
  editor.DomComponents.addType('eb-icon', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-icon'
    },
    model: {
      defaults: {
        name: 'Icon',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-icon' },
        style: {
          'text-align': 'center',
          'font-size': '40px',
          'color': '#667eea',
          'padding': '10px',
        },
        components: '<i class="fa fa-star"></i>',
        traits: [
          { type: 'text', name: 'data-icon-class', label: 'Icon Class (fa fa-...)', changeProp: true },
          { type: 'text', name: 'data-link', label: 'Link URL' },
        ],
      },
      init() {
        this.on('change:attributes:data-icon-class', this.updateIcon)
      },
      updateIcon() {
        const cls = this.getAttributes()['data-icon-class'] || 'fa fa-star'
        this.components(`<i class="${cls}"></i>`)
      },
    },
  })

  editor.BlockManager.add('eb-icon', {
    label: 'Icon',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"/></svg>',
    content: { type: 'eb-icon' },
  })
}
